var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "watermark",
      style: { height: _vm.windowHeight + "px", width: _vm.windowWidth + "px" }
    },
    [
      _vm.waterMarkType == 0
        ? _c(
            "div",
            { staticClass: "watermark_0" },
            _vm._l(_vm.waterMarkCount, function(index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "watermark_item_c",
                  style: {
                    width: _vm.waterMarkWidth + "px",
                    height: _vm.waterMarkHeight + "px",
                    left:
                      ((index - 1) % _vm.waterMarkColumn) * _vm.waterMarkWidth +
                      "px",
                    top:
                      parseInt((index - 1) / _vm.waterMarkColumn) *
                        _vm.waterMarkHeight -
                      50 +
                      "px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "watermark_item",
                      class: { white: index % 2 == 0 },
                      style: { paddingTop: _vm.waterMarkHeight / 2 + "px" }
                    },
                    [
                      _c("strong", [_vm._v(_vm._s(_vm.name))]),
                      _vm._v(" "),
                      _c("em", [
                        _vm._v(
                          _vm._s(
                            _vm._f("showPhoneOrEmail")(_vm.phone, _vm.email)
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.loginTime))])
                    ]
                  )
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.waterMarkType == 1
        ? _c(
            "div",
            { staticClass: "watermark_1" },
            _vm._l(_vm.waterMarkRow, function(row) {
              return _c(
                "div",
                { key: row, style: { height: _vm.warterRowHeight + "px" } },
                _vm._l(
                  row % 2 == 1 ? _vm.waterMarkColumn : _vm.waterMarkColumn - 1,
                  function(index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "watermark_item_c",
                        style: {
                          width: _vm.waterMarkWidth + "px",
                          height: _vm.waterMarkHeight + "px",
                          left:
                            ((index - 1) % _vm.waterMarkColumn) *
                              _vm.waterMarkWidth +
                            (row % 2 == 1 ? 0 : _vm.waterMarkWidth * 0.4) +
                            "px",
                          top: (row - 1) * _vm.warterRowHeight - 50 + "px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "watermark_item",
                            class: { white: index % 2 == 0 },
                            style: {
                              paddingTop: _vm.waterMarkHeight / 2 + "px"
                            }
                          },
                          [
                            _c("strong", [_vm._v(_vm._s(_vm.name))]),
                            _vm._v(" "),
                            _c("em", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("showPhoneOrEmail")(
                                    _vm.phone,
                                    _vm.email
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.loginTime))])
                          ]
                        )
                      ]
                    )
                  }
                ),
                0
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.waterMarkType == 2
        ? _c(
            "div",
            { staticClass: "watermark_2" },
            _vm._l(_vm.waterMarkRow, function(row) {
              return _c(
                "div",
                { key: row, style: { height: _vm.warterRowHeight + "px" } },
                _vm._l(_vm.waterMarkCount, function(index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "watermark_item_c",
                      style: {
                        width: _vm.waterMarkWidth + "px",
                        height: _vm.waterMarkHeight + "px",
                        left:
                          ((index - 1) % _vm.waterMarkColumn) *
                            _vm.waterMarkWidth +
                          "px",
                        top:
                          parseInt((index - 1) / _vm.waterMarkColumn) *
                            _vm.waterMarkHeight -
                          50 +
                          "px"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "watermark_item",
                          class: { white: index % 2 == 0 },
                          style: { paddingTop: _vm.waterMarkHeight / 2 + "px" }
                        },
                        [
                          _c("strong", [_vm._v(_vm._s(_vm.name))]),
                          _vm._v(" "),
                          _c("em", [
                            _vm._v(
                              _vm._s(
                                _vm._f("showPhoneOrEmail")(_vm.phone, _vm.email)
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.loginTime))])
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f72c2a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f72c2a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/waterMark.vue
// module id = null
// module chunks = 